import Vue from 'vue'
import entriesTransformer from '@/transformers/catalog/warehouse/entriesWithoutOC'

/**
 * @author jorge nuñez lópez <>
 *
 * Create a new entry without purchase order
 * @param payload New entry object
 * @return {object}
 */

export default (newEntryInfo, warehouseId) => {
  const payload = entriesTransformer.send(newEntryInfo)
  return Vue.$http.post(`iwarehouse/movement/${warehouseId}/in-without-buy-order/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/sendEntryWithoutPO.js